import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import styles from './Label.scss';

const Label = ({
  children = null,
  className = '',
  htmlFor = null,
  ...props
}) => {
  return (
    <label
      {...props}
      htmlFor={htmlFor}
      className={classnames(
        styles.Label,
        !htmlFor && styles.implicit,
        className,
      )}
    >
      {children}
    </label>
  );
};

Label.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.shape({}),
  htmlFor: PropTypes.string,
};

export default Label;
